let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bgYMf")).then(() => parcelRequire('bIGxD'));